module.exports = __webpack_public_path__ + "static/media/ar.3ae373fa.png";